import React, { Component } from "react";
import { Link } from "react-scroll";
var Scroll = require('react-scroll');
var scroll = Scroll.animateScroll;

export default class Header extends Component {
  constructor(props){
    super(props);
    this.state = {showMenu: false}
  }

  slideDown = () => {
    this.setState({
      showMessage: true
    });
  }
  slideBackUp = () => {
    this.setState({
      showMessage: false
    });
  }


  slideUp() {}

  render() {
    return (
        <div className="topbarbg">
          <div className= "contrainer">
            <div className="navrow">
              <div className="logoContainer">
                  <Link
                      to="video"
                      smooth={true}
                      offset={-70}
                      duration={500}
                  >
                    <img className="logo"
                      src={require("../../assets/img/TopNavLogo.png")}
                      alt="Top Logo"
                    />
                  </Link>
                </div>
              { !this.state.showMessage && (
              <div className="menuBtn" onClick={this.slideDown}>
                <img
                  src={require("../../assets/img/hamburger.png")}
                  alt="Hamburger Menu"
                />
              </div> )}
              { this.state.showMessage && (
                <div className="deleteMenu" onClick={this.slideBackUp}>
                <img
                  src={require("../../assets/img/blackX.png")}
                  alt="Hamburger Menu"
                />
              </div> )}


              <nav id="topnav" className="topnav">
                <ul id="fixed-nav" className="fixed-nav">
                  <li>
                      <Link
                        to="video"
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >
                        Home
                    </Link>
                  </li>
                  <li>
                      <Link
                          to="services"
                          smooth={true}
                          offset={-70}
                          duration={500}
                      >
                          Services
                      </Link>
                  </li>
                  <li>
                    <Link
                        to="platform"
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >
                        Platform
                    </Link>
                  </li>
                  <li>
                        <Link
                            to="team"
                            smooth={true}
                            offset={-70}
                            duration={500}
                        >
                            Team
                        </Link>
                        
                  </li>
                  <li>
                      <Link
                            to="jobs"
                            smooth={true}
                            offset={-70}
                            duration={500}
                        >
                            Careers
                        </Link>
                  </li>
                  <li>
                    <Link
                          to="contact"
                          smooth={true}
                          offset={-70}
                          duration={500}
                      >
                          Contact
                      </Link>
                  </li>
                </ul>
              </nav>
              <div className="getStarted">
                  <Link
                      to="contact"
                      smooth={true}
                      offset={-70}
                      duration={500}
                  >
                      Get Started
                    </Link>
              </div>
            </div>
          </div>
          { this.state.showMessage && (
          <div id="customNav" className="customNav">
            <ul id="">
              <li>
                  <Link 
                        className = "scroll-link" 
                        href= ""
                        onClick = {this.slideBackUp}
                        to="video"
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >
                        Home
                  </Link>
              </li>
              <li>
                  <Link 
                        className = "scroll-link" 
                        href= ""
                        onClick = {this.slideBackUp}
                        to="services"
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >
                        Services
                  </Link>
              </li>
              <li>
                  <Link 
                        className = "scroll-link" 
                        href= ""
                        onClick = {this.slideBackUp}
                        to="platform"
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >
                        Platform
                  </Link>
              </li>
              <li>
                 <Link 
                        className = "scroll-link" 
                        href= ""
                        onClick = {this.slideBackUp}
                        to="team"
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >
                        Team
                  </Link>
              </li>
              <li>
                  <Link 
                        className = "scroll-link" 
                        href= ""
                        onClick = {this.slideBackUp}
                        to="jobs"
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >
                        Careers
                  </Link>
              </li>
              <li>
                 <Link 
                        className = "scroll-link" 
                        href= ""
                        onClick = {this.slideBackUp}
                        to="contact"
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >
                        Contact
                  </Link>
              </li>
            </ul>
          </div>)}
        
        </div>
      
    );
  }
}
